export default __webpack_public_path__ + "static/media/hht1_ep10_timeline_q03_b.e7fb5e4f.png";